import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import getSummaryText from './getSummaryText'
import { calculateDaysBetweenDates } from './helper'

const ReservationCalendarSummary = ({ amenity, calendarValues, selectedTime }) => {
  const { t } = useTranslation(['reservations'])
  const { multiDayBooking, minimumDays, maximumDays } = amenity
  const timeIsNotSelected =
    amenity.timeInterval >= amenity.minTime
      ? !selectedTime || typeof selectedTime.startTime !== 'number'
      : !selectedTime || typeof selectedTime.startTime !== 'number' || !selectedTime.endTime
  const isDaysSelected = Array.isArray(calendarValues) && calendarValues.length > 0

  if (multiDayBooking && calendarValues && calendarValues.length === 2) {
    const daysBetweenDates = calculateDaysBetweenDates(calendarValues)
    if (
      (minimumDays && daysBetweenDates < minimumDays) ||
      (maximumDays && daysBetweenDates > maximumDays)
    ) {
      return (
        <div className="reservation-calendar-summary warning">
          <b>{t('reservations:reservationCalendarSummary.warning')}</b>
          <p>
            {daysBetweenDates < minimumDays
              ? t('reservations:reservationCalendarSummary.minimumDaysRequired', {
                  minimumDays,
                })
              : t('reservations:reservationCalendarSummary.maximumDaysRequired', {
                  maximumDays,
                })}
          </p>
        </div>
      )
    }
  }

  if (
    !isDaysSelected ||
    (calendarValues.length === 1 && multiDayBooking) ||
    (!multiDayBooking && timeIsNotSelected)
  ) {
    return null
  }

  let summaryText = getSummaryText(amenity, calendarValues, selectedTime, false, t)

  return (
    <div className="reservation-calendar-summary">
      <b>{t('reservations:reservationCalendarSummary.summary')}</b>
      <p>{summaryText}</p>
    </div>
  )
}

ReservationCalendarSummary.propTypes = {
  amenity: PropTypes.object,
  selectedTime: PropTypes.object,
  calendarValues: PropTypes.array,
}

export default ReservationCalendarSummary
